import { Expose } from 'class-transformer';
import { BaseModel } from '../../../common-sdk';

export class ProjectPersonModel extends BaseModel {
  @Expose()
  name: string | undefined;

  @Expose()
  invoicing: boolean | undefined = false;

  @Expose()
  salesperson: boolean | undefined = false;
}
